import {
  IconBuildingChurch,
  IconCake,
  IconCamera,
  IconCar,
  IconClock,
  IconConfetti,
  IconEye,
  IconFlower,
  IconGift,
  IconGlassChampagne,
  IconGlassCocktail,
  IconHanger,
  IconHeart,
  IconMapPin,
  IconMicrophone,
  IconMusic,
  IconRings,
  IconScript,
  IconSparkles,
  IconSunset,
  IconToolsKitchen2,
  IconVinyl,
} from "@tabler/icons-react";
import type { TimelineIconKey } from "../../utils/timeline";

/** Maps each curated timeline icon key to its @tabler glyph. */
const ICONS: Record<TimelineIconKey, typeof IconClock> = {
  "getting-ready": IconHanger,
  "first-look": IconEye,
  ceremony: IconBuildingChurch,
  rings: IconRings,
  vows: IconScript,
  photos: IconCamera,
  cocktails: IconGlassCocktail,
  toast: IconGlassChampagne,
  dinner: IconToolsKitchen2,
  cake: IconCake,
  speeches: IconMicrophone,
  "first-dance": IconVinyl,
  music: IconMusic,
  party: IconConfetti,
  flowers: IconFlower,
  sunset: IconSunset,
  sparklers: IconSparkles,
  transport: IconCar,
  gift: IconGift,
  heart: IconHeart,
  venue: IconMapPin,
  clock: IconClock,
};

/** Renders the glyph for an icon key, falling back to a clock. */
export const TimelineIcon = ({ iconKey }: { iconKey: string }) => {
  const Icon = ICONS[iconKey as TimelineIconKey] ?? IconClock;
  return <Icon />;
};
